import script from "./LocationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationsPage.vue?vue&type=script&setup=true&lang=js"

import "./LocationsPage.vue?vue&type=style&index=0&id=47ac858c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ac858c"]])

export default __exports__